/**
 * @file notificationPrefs.js
 *
 * Notification Preferences API Service
 *
 * API calls to /api/v1/professional/me/notification-preferences.
 * The professional's per-event × per-channel notification matrix (what THEY
 * receive — never affects patient notifications).
 */
import api from "./api";

export const notificationPrefsService = {
  /** Get the stored matrix, or the default all-on matrix if none saved yet. */
  get: () => api.get("/professional/me/notification-preferences"),

  /** Save the full matrix. Returns the saved matrix. */
  update: (prefs) => api.put("/professional/me/notification-preferences", prefs),
};
